import { render } from "./CreateEditRFID.vue?vue&type=template&id=3e9a10cc&ts=true"
import script from "./CreateEditRFID.vue?vue&type=script&lang=ts"
export * from "./CreateEditRFID.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__